export default {
  baseUrl: 'https://qa-apit9.lqfast.com',
  lqBaseUrl: parent.location.origin,
  lqAssetsServeUrl: 'https://lq-shangcheng.obs.cn-east-3.myhuaweicloud.com/t9bs'
}
